import { useLang } from '@/app/utils/useLang';
import VideoSection from '../Common/VideoSection';
import styles from './index.module.scss';

const CoverSection3: React.FC = () => {
    const { t } = useLang('CoverSection3');

    return (
        <div className={`page-coverSection3 ${styles.CoverSection3} GtmModuleData-section`} id="CoverSection3" data-section-id="d3m-video-section3">
            <VideoSection
                sectionId="videoSection3"
                triggerSelector="#videoSection3"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759041363570/2-03.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758871228430-2so2nq-compressed-3.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection3;
